import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { SHARED_COMPONENTS } from '../../../shared/shared-imports';
import { RoutesPath } from '../../../shared/constants/routes-path';
import { environment } from '../../../../environments/environment';

@Component({
  standalone: true,
  selector: 'app-forgot-password',
  imports: [CommonModule, ReactiveFormsModule, TranslateModule, ...SHARED_COMPONENTS],
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.css'
})
export class ForgotPasswordComponent {
  recoverForm: FormGroup;
  isSubmitting = false;
  isSuccess = false;
  supportEmail = environment.ssoSupportEmail;
  // private readonly recoverUrl = `${environment.wso2APIURL}DCAuthToken/Recovery/RecoverPassword`;
  private readonly recoverUrl = `${environment.wso2APIURL}DCAuthToken/Recovery/InitiatePasswordReset`;


  constructor(private fb: FormBuilder, private router: Router, private http: HttpClient) {
    this.recoverForm = this.fb.group({
      username: ['', Validators.required]
    });
  }
  showErrorMsg: boolean = false;
  submit() {
    if (this.recoverForm.invalid) {
      this.recoverForm.markAllAsTouched();
      return;
    }
    if (this.isSubmitting) {
      return;
    }
    this.showErrorMsg = false;
    this.isSubmitting = true;
    const { username } = this.recoverForm.value;
    this.http.post(this.recoverUrl, { username }).subscribe({
      next: (response: any) => {
        if (response?.code != 'FAILURE') {
          this.isSuccess = true;
        } else {
          this.showErrorMsg = true;
          return;
        }
        this.isSuccess = true;
      },
      error: () => {
        this.isSubmitting = false;
      },
      complete: () => {
        this.isSubmitting = false;
      }
    });
  }

  cancel() {
    this.router.navigate(['/', RoutesPath.PUBLIC.LOGIN]);
  }

  backToApplication() {
    this.router.navigate(['/', RoutesPath.PUBLIC.LOGIN]);
  }
}
